/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Descriptionplaceholder1Inputs */

const zh_course_descriptionplaceholder1 = /** @type {(inputs: Course_Descriptionplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`简要描述课程内容...`)
};

const en_course_descriptionplaceholder1 = /** @type {(inputs: Course_Descriptionplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Briefly describe the course...`)
};

const es_course_descriptionplaceholder1 = /** @type {(inputs: Course_Descriptionplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe brevemente el curso...`)
};

/**
* | output |
* | --- |
* | "Briefly describe the course..." |
*
* @param {Course_Descriptionplaceholder1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const course_descriptionplaceholder1 = /** @type {((inputs?: Course_Descriptionplaceholder1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Descriptionplaceholder1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_course_descriptionplaceholder1(inputs)
	if (locale === "en") return en_course_descriptionplaceholder1(inputs)
	return es_course_descriptionplaceholder1(inputs)
});
export { course_descriptionplaceholder1 as "course_descriptionPlaceholder" }